var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { ensureError } from '.';
var Placeholder = /** @class */ (function () {
    function Placeholder() {
        this.__PLACEHOLDER__ = '__PLACEHOLDER__';
        // Fix instanceof bug: https://github.com/microsoft/TypeScript/issues/22585
        Object.setPrototypeOf(this, Placeholder.prototype);
    }
    return Placeholder;
}());
/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of their positions.
 *
 * @category FP
 */
export var __ = new Placeholder();
export function pipe(value) {
    var operations = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        operations[_i - 1] = arguments[_i];
    }
    return operations.reduce(function (prev, cur) { return cur(prev); }, value);
}
export function compose() {
    var operations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        operations[_i] = arguments[_i];
    }
    return function (value) { return pipe.apply(void 0, __spreadArray([value], __spreadArray([], operations).reverse())); };
}
export function curry(func) {
    return function curried() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (args.some(function (v) { return v instanceof Placeholder; })) {
            return function () {
                var args2 = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args2[_i] = arguments[_i];
                }
                var args2Copy = __spreadArray([], args2);
                var argsCopy = args.map(function (v) {
                    return v instanceof Placeholder && args2Copy.length
                        ? args2Copy.shift()
                        : v;
                });
                return curried.apply(this, argsCopy.concat(args2Copy));
            };
        }
        if (args.length >= func.length) {
            return func.apply(this, args);
        }
        else {
            return function () {
                var args2 = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args2[_i] = arguments[_i];
                }
                return curried.apply(this, args.concat(args2));
            };
        }
    };
}
export function tryCatch(callback, defaultValue) {
    var defaultValueProvided = arguments.length === 2;
    var handleError = function (err) {
        var error = ensureError(err);
        if (defaultValueProvided) {
            return defaultValue;
        }
        return error;
    };
    try {
        var result = callback();
        if (typeof Promise !== 'undefined' && result instanceof Promise) {
            return result["catch"](handleError);
        }
        return result;
    }
    catch (err) {
        return handleError(err);
    }
}
